

var Swal = require('sweetalert2/dist/sweetalert2.js');
var toastr = require('toastr');

module.exports = {
    badge: function (str, barge_style = null, getMapOnly = false) {
        if (!str) return null;
        const styleMap = {
            'recurring': 'alternate',
            'in_progress': 'info',
            'one_time': 'primary',
            'one_time_bidding': 'info',
            'paid': 'primary',
            'pending': 'warning',
            'completed': 'success',
            'transfer_in_progress': 'info',
            'active': 'success',
            'inactive': 'secondary',
            'hold': 'warning',
            'task_done': 'primary',
            'cancelled': 'danger',
        };
        if (getMapOnly) return styleMap[str] ?? barge_style ?? 'dark';

        const badges = str.split(',');
        const createBadge = (s) => {
            const cleanStr = s.trim().toLowerCase().replace(/[^a-zA-Z0-9_]/g, '');
            const beautiStr = s.trim().replace(/_/g, ' ');
            const classStr =  styleMap[cleanStr] || barge_style || 'dark';
            return `<span class="badge badge-${classStr}">${beautiStr}</span>`;
        };

        return badges.map(createBadge).join('');
    },


    isEmpty: function(obj){
        if (obj == null) return true;
        if (obj.length > 0)    return false;
        if (obj.length === 0)  return true;
        if (typeof obj !== "object") return true;
        return true;
    },

    slugify: function(string){
        return string
            .toLowerCase()
            .replace(/[^\w ]+/g,'')
            .replace(/ +/g,'_');
    },


    date_time: function (date) {
        if(!date) return '(empty)';
        return moment(date).format('DD MMM, YYYY · h:mm A');
    },

    date_format: function (date) {
        if(!date) return '(empty)';
        return moment(date).format(date_format);
    },

    human_time: function (date) {
        if (!date) return '(empty)';
        return moment(date).fromNow();
    },

    removeTags: function (str) {
        if ((str===null) || (str==='')) return false;
        str = str.toString();
        return str.replace( /(<([^>]+)>)/ig, '');
    },

    remove_dom: function (elem, data_parent = null){
        elem.css({"background":'#b2bec3', 'transition': 'linear background .3s'}).delay(300).queue(function(){
            $(this).remove();
            if($(data_parent).length){
                $(data_parent).trigger('change')
            }
        });
    },

    highlight: function (elem){
        elem.addClass('highlight')
        setTimeout(function () {
            elem.removeClass('highlight');
        }, 400);
    },

    excerpt: function (str, limit = 40){
        if (!str) return '(empty)';
        str = this.removeTags(str)
        if(str.length > limit){
            var excerpt = str.substring(0, limit);
            return '<span data-toggle="tooltip-light" data-original-title="'+str+'">'+excerpt+'...</span>';
        }else{
            return str;
        }
    },

    loading: function(str = ''){
        return '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> '+str;
    },

    tick: function(str = ''){
        return $('<i class="fas fa-check ml-2 text-success"></i>');
    },

    sweetConfirm: function(title, message, callback, confirmText = "Ok", cancelText = "Cancel") {
        if((typeof Swal !== 'undefined')){
            Swal.fire({
                title: title,
                text: (message)?message:'Click ok to proceed!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: confirmText,
                cancelButtonText: cancelText
            }).then((confirmed) => {
                callback(confirmed && confirmed.value == true);
            });
        }else{
            if(confirm(title)){
                callback(true)
            }
        }
    },

    alert: function(title, message) {
        if((typeof Swal !== 'undefined')){
            Swal.fire({
                title: title,
                text: (message)?message:'Click ok to proceed!',
                icon: 'warning',
                showCancelButton: false
            })
        }else{
            alert(message)
        }
    },

    setItem: function(key, data){
        return localStorage.setItem(key, JSON.stringify(data))
    },

    getItem: function(key){
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            return false;
        }
    },

    uid: function(length = 6) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
        }
        return result;
    },
    /**
     *
     * @param {url_path} url_path url path after base_url
     */
    redirect: function(url_path){
        window.location.replace(url_path);
    },

    array_search: function(array, attr, value) {
        if( typeof array  == 'undefined') return -1;
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    },

    isValid: function(divObj, controls){
        let valid = true;
        $(divObj).find('.form-control').each(function(i, obj) {
            obj.checkValidity()
            if(obj.validity.valid == false){
                valid = false;
            }
        });
        return valid;
    },

    validate: function(divObj, controll_class){
        $(divObj).find(controll_class).each(function(i, obj) {
            console.log("Validating...")
            console.log("AB:",obj.validity.valid);
            obj.checkValidity()
            if(obj.validity.valid == false){
                if($(obj).parent().find('.invalid-feedback').length){
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage).removeClass('d-block').addClass('d-block');
                }else{
                    $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback d-block">'+obj.validationMessage+'</em>');
                }
            }
        });
    },

    realTimeValidate: function(divObj){
        $(divObj).find('.form-control').each(function(i, obj) {

            $(document).on('input', obj, function(e) {
                obj.checkValidity()
                if(obj.validity.valid == true){
                    $(obj).parent().find('.invalid-feedback').removeClass('d-block');
                    return true;
                }
                if($(obj).parent().find('.invalid-feedback').length){
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage).removeClass('d-block').addClass('d-block');
                }else{
                    $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback d-block">'+obj.validationMessage+'</em>');
                }
            });
        });
    },

    /**
     * @param {url || html element containing href attr} any
     *
     */
    ajaxModal: function(elem){
        let elemIsString = false;
        if( typeof elem === 'string' || elem instanceof String ){
            //passed string
            var link = elem;
            elemIsString = true;
        }else{
            if($(elem).length){
                var link = $(elem).attr('href');

                var _loadable_div = ['a', 'button', 'input'];
                if( _loadable_div.includes($(elem).prop("tagName").toLowerCase()) ){
                    var str_loading = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Loading...';
                    if($(elem).html() != str_loading){
                        var elem_content = $(elem).html();
                    }
                    $(elem).html(str_loading);
                }
            }
        }
        // console.log(link)
        // return 0

        $.ajax({
            url: link,
            type: 'GET',
            success: function(data) {
                // if ajax-modal req response is JSON object shoiw toast notification
                if(typeof data == 'object'){
                    toastr.options = {
                        "debug": false,
                        "newestOnTop": true,
                        "progressBar": true,
                        "positionClass": "toast-bottom-right",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    };
                    toastr[data.status](data.message);
                    return false;
                }

                if(!elemIsString){
                    if($(elem).length){
                        setTimeout(() => {
                            $(elem).html(elem_content);
                        }, 500);
                    }
                }

                $('#myModal').html(data).modal({backdrop: 'false'});
                $('#myModal').attr('data-source', link);

                $('[data-toggle="tooltip"]').tooltip();
                $('[data-toggle="tooltip-light"]').tooltip({
                    template: '<div class="tooltip tooltip-light"><div class="tooltip-inner"></div></div>'
                });

                $('#myModal').find('.select2').select2({
                    theme:"bootstrap4",
                    width: '100%'
                });
                $('#myModal').find('.select2-tag').select2({
                    theme:"bootstrap4",
                    width: '100%',
                    tags: true,
                });

                $('#myModal').find('.random').val(beautify.uid(7));
                $('#myModal').find('.focus').trigger('focus').trigger('select')

                $('#myModal').find('.datatable-minimal-offers').DataTable({
                    dom: 'tp', // Only table (t) and pagination (p)
                    columnDefs: [
                        {
                            targets: [0, -1], // first and last column
                            orderable: false
                        }
                    ],
                    order: [] // prevents default initial sorting
                })
                // $('#myModal').find('.summernote').summernote({
                //     toolbar: [
                //         [ 'style', [ 'style' ] ],
                //         [ 'font', [ 'bold', 'italic', 'underline', 'strikethrough'] ],
                //         [ 'fontsize', [ 'fontsize' ] ],
                //         [ 'color', [ 'color' ] ],
                //         [ 'para', [ 'ol', 'ul', 'paragraph', 'height' ] ],
                //         [ 'table', [ 'table' ] ],
                //         [ 'view', ['codeview'] ]
                //     ]
                // });

                $('#myModal').find('[data-toggle=toggle]').bootstrapToggle();

                $('#myModal .datepicker').datepicker({
                    todayHighlight: true,
                    autoclose: true,
                    format: 'yyyy-mm-dd',
                    weekStart: 1
                }).trigger('change');

                $(document).trigger('ajax-modal-loaded');

                mdtimepicker('#myModal .timepicker', {
                    timeFormat: 'hh:mm:ss.000',
                    format: 'h:mm tt',
                    theme: 'teal',
                    hourPadding: true
                });

                $('#myModal').find('.decimal, .float, .double, .percentage').attr('autocomplete', 'off');

                $('#myModal').find('.drop_image').inputFileZone({
                    upload_url: url + '/api/upload/images',
                    file_types_allowed: ['image/jpeg', 'image/png', 'image/vnd.adobe.photoshop'],
                    max_file_size: 5 * 1024 * 1024, // 5MB
                    height: '100px',
                    width: '100px'
                })
            },
            error: function(){

                toastr.options = {
                    "debug": false,
                    "newestOnTop": true,
                    "progressBar": true,
                    "positionClass": "toast-bottom-right",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                };
                toastr['error']('Oops! Something went wrong. Please refresh and try again.');
            }
        });

        if(!elemIsString){
            if($(elem).length){
                setTimeout(() => {
                    $(elem).html(elem_content);
                }, 5000);
            }
        }
    },
    notification: function(message, type='info'){
        toastr.options = {
            "debug": false,
            "newestOnTop": true,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
        toastr[type](message);
    },
    reverseSlug: function(slug){
        if (typeof slug !== 'string') return slug;
        return slug
            .replace(/[-_]/g, ' ')          // Replace hyphens and underscores with spaces
            .replace(/\s+/g, ' ')           // Remove extra spaces if any
            .trim()                         // Trim spaces at the start and end
            .replace(/\b\w/g, function (l) {
            return l.toUpperCase();       // Capitalize the first letter of each word
            });
    },
    rerender: function(){
        var current_url = window.location.href;
        $target = $('.app-main');
        $target.block({
            message: $(
                `<div class="loader mx-auto">
                    <div class="line-scale-pulse-out">
                        <div class="bg-success"></div>
                        <div class="bg-success"></div>
                        <div class="bg-success"></div>
                        <div class="bg-success"></div>
                        <div class="bg-success"></div>
                    </div>
                </div>`
            ),
            css: {
                border: 'none',
                backgroundColor: 'transparent',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: 0,
                margin: 0,
                width: 'auto', // <- override the default 30%
            },
            centerY: false,
        })
        $.ajax({
            url: current_url,
            type: 'GET',
            success: function(data) {
                var parsedHtml = $.parseHTML(data);
                if ($(parsedHtml).find($target).length <= 0){
                    $target = '.app-main';
                }
                $($target).html($(parsedHtml).find($target).html()).trigger('change');
                $(document).trigger('rendered');
            }
        });
    }

}
